const {Component} = require("react"); 
const PropTypes = require("prop-types");
const router = require("services/router");
const moment = require("moment");
const {queryObject} = require("helpers/object");

class BalanceEntry extends Component { 

	/*
	 -------------------------------
	 Init
	 -------------------------------
	 */

	static get typeTranslation() {
		return {

			/*
			 * Oficial
			 */
			//adjustment: '',
			//application_fee: '',
			//application_fee_refund: '',
			//charge: '',
			payment: 'Indbetaling',
			//payment_failure_refund: '',
			//payment_refund: '',
			//refund: '',
			//transfer: '',
			//transfer_refund: '',
			payout: 'Udbetaling',
			//payout_cancel: '',
			//payout_failure: '',
			//validation: '',
			//stripe_fee: '',
			//network_cost: '',

			/*
			 * Custom
			 */
			payment_refund: 'Tilbageført',
			compensation: 'Kompensation',
			fee: 'Gebyr',
		}
	}

	static get propTypes() {
		return {
			amount: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
			status: PropTypes.string.isRequired,
			created: PropTypes.number.isRequired,
			available: PropTypes.number.isRequired,
		};
	}


	/*
	 -------------------------------
	 Getters
	 -------------------------------
	 */

	get amount() {
		return this.props.amount
			.toLocaleString('da', {minimumFractionDigits: 2, maximumFractionDigits: 2});
	}

	get entryStatus() {
		let stat = this.props.status;

		if (stat === 'available') return 'Gennemført';
		if (stat === 'pending') return 'Afventer';
		return '-';
	}

	get metadata() {
		return this.props.metadata || {};
	}

	get type() {
		let {type} = this.props;

		if (this.metadata && this.metadata.type) {
			type = this.metadata.type;
		}

		return queryObject(BalanceEntry.typeTranslation, type, this.props.type);
	}

	get created() {
		return moment.unix(this.props.created).format('YYYY/DD/MM HH:mm:ss');
	}

	get available() {
		return 'Tilgængelig fra ' + moment.unix(this.props.available).format('YYYY/DD/MM HH:mm:ss');
	}

	/*
	 -------------------------------
	 Renders
	 -------------------------------
	 */

	renderMetadata() {
		if (!this.metadata) return;

		const customer = this.metadata.customer ?
			(<td className="customer payment-col">
				<span>Kunde</span>
				<p>{this.metadata.customer}</p>
			</td>)
			: (<td className="customer payment-col"><span></span><p></p></td>);

		const booking = this.metadata.booking_time ?
			(<td className="description payment-col">
				<span>Booking</span>
				<p>{moment.unix(this.metadata.booking_time).format('YYYY/DD/MM HH:mm:ss')}</p>
			</td>)
			: (<td className="description payment-col"><span></span><p></p></td>);

		return (
			<React.Fragment>
				{customer}
				{booking}
			</React.Fragment>
		);
	}

	render() {
		return (
			<tr>

				<td><img src={router.url('img/icons/credit-card.svg')} alt="Amount" /></td>

				<td className="amount">
					<p>{this.props.currency} {this.amount}</p>
				</td>

				<td className="type payment-col">
					<span>Type</span>
					<p>{this.type}</p>
				</td>

				<td title={this.available} className="status payment-col">
					<span>Status</span>
					<p>{this.entryStatus}</p>
				</td>

				<td className="date payment-col">
					<span>Oprettet</span>
					<p>{this.created}</p>
				</td>

				{this.renderMetadata()}
			</tr>
		);
	}
}

module.exports = BalanceEntry; 



// WEBPACK FOOTER //
// ./resources/js/components/backend/balance/BalanceEntry.js